import { useCompatQuery } from './useApolloCompat';
import { SCHEDULE_TEMPLATES_QUERY } from '../graphql/operations';

export function useScheduleTemplates() {
  return useCompatQuery(SCHEDULE_TEMPLATES_QUERY);
}
